export default "__VITE_ASSET__Dl2H4qO3__"